import React from "react";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import LoginForm from './LoginForm'
import {login} from "../../../store/auth-reducer";



const LoginContainer = props => {
    const {isAuth, login} = props
    if (isAuth) return <Redirect to={"/profile"}/>
    return <LoginForm login={login}/>

}
const mapStateToProps = (state) => ({isAuth: state.auth.isAuth})

export default connect(mapStateToProps,{login})(LoginContainer);



